import React, { useRef, useState } from "react";
import { Map } from "lucide-react";
import { CompanyRef } from "../companyScreen/company";
import IFtAdetails, { IFTARef } from "../IFtAdetails";
import Search from "../../components/serchcomponet/search";
import Dropdown from "../../components/UIElements/Dropdown";
import AddButton from "../../components/UIElements/AddButton";
import { useOutletContext } from "react-router-dom";
import SlidingTabs from "../../components/UIElement/MainSlidingTabs";
import PoliciesPlans, { PoliciesRef } from "../policiesplans/PoliciesPlans";

type LayoutContext = {
  isExpanded: boolean;
};

export default function TMSPage() {
  
  const { isExpanded } = useOutletContext<LayoutContext>();
  const [selectedTab, setSelectedTab] = useState<any>(2);

  // company states
  const companyRef = useRef<CompanyRef>(null);
  const companyFilterOptions = [
    "All",
    "BROKER",
    "CARRIER",
    "SHIPPER",
    "BROKER&CARRIER",
  ];

  // IFTA states
  const IFTARef = useRef<IFTARef>(null);
  const [iftaSelectedTab, setIFTASelectedTab] = useState<number>(1);

  // Policies states
  const PoliciesRef = useRef<PoliciesRef>(null);
  const [PoliciesSelectedTab, setPoliciesSelectedTab] = useState<number>(1);

  const clickTab = (tabIndex: React.SetStateAction<number>) => {
    setSelectedTab(tabIndex);
  };

  return (
    <div className="flex text-textColor  bg-customGray font-sans relative ">
      <div className='flex flex-col flex-1 sm:w-4/5 p-0"'>
        <div className=" bg-gray-100 p-0">
          {/* Top bar */}
          {selectedTab === 1 && (
            <div
            className={`flex items-center h-[49px] justify-between
  bg-white/40 backdrop-blur-md border border-white/30 shadow-lg
  fixed top-0 z-[9] transition-all duration-200 ease-in px-4
 ${isExpanded ? "left-[230px] w-[calc(100%-228px)]" : "left-[73px] w-[calc(100%-70px)]"}`}
          >
              {/* Left: icon and Breadcrumbs */}
              <div className="flex items-center space-x-6">
                <div className="flex items-center space-x-2">
                  <Map />
                  <span className="font-bold text-lg">TMS Users</span>
                </div>
              </div>
              {/* Right: Search & Button */}
              <div className="flex items-center space-x-2">
                {selectedTab === 1 && (
                  <Search
                    search={""}
                    onSearchChange={function (value: string): void {
                      companyRef.current?.searchChange(value);
                    }}
                    onClick={function (): void {
                      companyRef.current?.searchSubmit();
                    }}
                  />
                )}
                <Dropdown
                  options={companyFilterOptions}
                  onChange={(value) => {
                    companyRef.current?.filterChange(value);
                  }}
                ></Dropdown>
              </div>
            </div>
          )}

          {selectedTab === 2 && (
            <div
            className={`flex items-center h-[49px] justify-between
  bg-white/40 backdrop-blur-md border border-white/30 shadow-lg
  fixed top-0 z-[9] transition-all duration-200 ease-in px-4
 ${isExpanded ? "left-[230px] w-[calc(100%-228px)]" : "left-[73px] w-[calc(100%-70px)]"}`}
          >
              {/* Left: icon and Breadcrumbs */}
              <div className="flex items-center space-x-6">
                <div className="flex items-center space-x-2">
                  <svg viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 pl-[2px]"><path fill="#231f20" d="M43.125 4.5H6.875A2.377 2.377 0 0 0 4.5 6.875v36.25A2.377 2.377 0 0 0 6.875 45.5h36.25A2.377 2.377 0 0 0 45.5 43.125V6.875A2.377 2.377 0 0 0 43.125 4.5ZM44.5 43.125A1.377 1.377 0 0 1 43.125 44.5H6.875A1.377 1.377 0 0 1 5.5 43.125V6.875A1.377 1.377 0 0 1 6.875 5.5h36.25A1.377 1.377 0 0 1 44.5 6.875Z" /><path fill="#231f20" d="M40 39.5h-.375V12a2.5 2.5 0 0 0-2.5-2.5H35.5A2.5 2.5 0 0 0 33 12v27.5h-4.623V22a2.5 2.5 0 0 0-2.5-2.5h-1.625a2.5 2.5 0 0 0-2.5 2.5v17.5h-4.123V32a2.5 2.5 0 0 0-2.5-2.5H13a2.5 2.5 0 0 0-2.5 2.5v7.5H10a.5.5 0 0 0 0 1H40a.5.5 0 0 0 0-1Z" /><path fill="#00a1d3" d="M34 12a1.5 1.5 0 0 1 1.5-1.5h1.625a1.5 1.5 0 0 1 1.5 1.5V39.5H34Z" /><path fill="#ff8e5a" d="M22.752 22a1.5 1.5 0 0 1 1.5-1.5h1.625a1.5 1.5 0 0 1 1.5 1.5V39.5h-4.625Z" /><path fill="#ffba50" d="M11.5 32A1.5 1.5 0 0 1 13 30.5h1.625a1.5 1.5 0 0 1 1.5 1.5v7.5H11.5Z" /><path fill="#231f20" d="M10 10.5h6.587a.5.5 0 0 0 0-1H10a.5.5 0 0 0 0 1ZM10 13.415h6.587a.5.5 0 0 0 0-1H10a.5.5 0 0 0 0 1ZM10 16.331h6.587a.5.5 0 0 0 0-1H10a.5.5 0 0 0 0 1Z" /></svg>
                  <span className="font-bold text-lg">IFTA</span>
                </div>
              </div>
              {/* Right: Search & Button */}
              <div className="flex items-center space-x-2">
                {iftaSelectedTab === 1 && (
                  <div className="loadsheadcard ">
                    <AddButton
                      label="Add IFTA State"
                      onClick={() => {
                        IFTARef?.current?.addEditModelAdd_IFTA_Feature();
                      }}
                    ></AddButton>
                  </div>
                )}
                {iftaSelectedTab === 2 && (
                  <div className="loadsheadcard ">
                    <AddButton
                      label="Add Special State"
                      onClick={() => {
                        IFTARef?.current?.addEditModelPerMileTaxReportopen();
                      }}
                    ></AddButton>
                  </div>
                )}
              </div>
            </div>
          )}

          {selectedTab === 3 && (
            <div
            className={`flex items-center h-[49px] justify-between
  bg-white/40 backdrop-blur-md border border-white/30 shadow-lg
  fixed top-0 z-[9] transition-all duration-200 ease-in px-4
 ${isExpanded ? "left-[230px] w-[calc(100%-200px)]" : "left-[73px] w-[calc(100%-70px)]"}`}
          >
              {/* Left: icon and Breadcrumbs */}
              <div className="flex items-center space-x-6">
                <div className="flex items-center space-x-2">
         <svg
  viewBox="0 -143 1310 1310"
  xmlns="http://www.w3.org/2000/svg"
  className="h-6 w-6 pl-[2px]"
  fill="currentColor"
>
  <path d="M64 672c32.42752 28.16 69.97248 42.24 112.64 42.24s79.78752-14.08 111.36-42.24S337.92 608.42752 343.04 565.76H7.68c5.12 42.66752 23.89248 78.08 56.32 106.24zM896 880.64H407.04c-6.82752 0-12.8 2.56-17.92 7.68s-7.68 11.52-7.68 19.2 2.56 14.08 7.68 19.2 11.09248 7.68 17.92 7.68h488.96c17.06752 0 25.6-8.96 25.6-26.88s-8.53248-26.88-25.6-26.88zM384 947.2h535.04v76.8H384zM1022.72 672c31.57248 28.16 68.69248 42.24 111.36 42.24s80.21248-14.08 112.64-42.24 51.2-63.57248 56.32-106.24H967.68c5.12 42.66752 23.46752 78.08 55.04 106.24zM1292.8 514.56l-135.68-189.44h71.68c10.24 0 18.34752-3.41248 24.32-10.24s8.96-14.50752 8.96-23.04-2.98752-16.21248-8.96-23.04-14.08-10.24-24.32-10.24H839.68c-11.94752-30.72-30.72-57.6-56.32-80.64S727.89248 140.8 693.76 135.68V33.28c0-8.53248-3.41248-16.21248-10.24-23.04s-14.50752-10.24-23.04-10.24h-7.68c-8.53504 0-15.79008 3.41248-21.76 10.24-5.97248 6.82752-8.96 14.50752-8.96 23.04v102.4c-34.13248 5.12-64.42752 19.2-90.88 42.24S485.54752 227.84 473.6 258.56H84.48c-8.53248 0-16.21248 3.41248-23.04 10.24s-10.24 14.50752-10.24 23.04 3.41248 16.21248 10.24 23.04 14.50752 10.24 23.04 10.24h69.12L17.92 514.56H0v33.28h350.72v-33.28h-17.92l-135.68-189.44h317.44c0-6.82752 0.85248-14.50752 2.56-23.04 1.70752-3.41248 2.56-5.97248 2.56-7.68 5.12-25.6 17.06752-47.78752 35.84-66.56s40.96-31.57248 66.56-38.4v360.96h-2.56c-1.70752 64.85248-17.06752 125.44-46.08 181.76s-67.41248 101.54752-115.2 135.68h399.36c-49.49248-34.13248-88.74752-79.36-117.76-135.68s-44.37248-116.90752-46.08-181.76V189.44c23.89504 6.82752 45.23008 19.62752 64 38.4 18.77248 18.77248 30.72 40.96 35.84 66.56 1.70752 1.70752 2.56 4.26752 2.56 7.68 1.70752 8.53248 2.56 16.21248 2.56 23.04h314.88l-135.68 189.44h-17.92v35.84h350.72v-35.84h-17.92z m-1131.52 0H51.2l110.08-151.04v151.04z m138.24 0H189.44v-151.04l110.08 151.04z m821.76 0h-110.08l110.08-151.04v151.04z m28.16 0v-151.04l110.08 151.04h-110.08zM175.36 245.76c9.38752 0 17.06752-2.98752 23.04-8.96s8.96-13.65248 8.96-23.04-2.98752-17.06752-8.96-23.04-13.65248-8.96-23.04-8.96-17.06752 2.98752-23.04 8.96-8.96 13.65248-8.96 23.04 2.98752 17.06752 8.96 23.04 13.65248 8.96 23.04 8.96zM1135.36 245.76c9.38752 0 17.06752-3.41248 23.04-10.24s8.96-14.50752 8.96-23.04-2.98752-16.21248-8.96-23.04-13.65248-10.24-23.04-10.24-17.06752 3.41248-23.04 10.24-8.96 14.50752-8.96 23.04 2.98752 16.21248 8.96 23.04 13.65248 10.24 23.04 10.24z" />
</svg>



                  <span className="font-bold text-lg">Policies</span>
                </div>
              </div>
              {/* Right: Search & Button */}
              <div className="flex items-center space-x-2">
                {PoliciesSelectedTab === 3 && (
                  <div className="loadsheadcard ">
                    <AddButton
                      onClick={() => {
                        PoliciesRef?.current?.AddSelet_plan();
                      }}
                      label="Add Billing Plan"
                    ></AddButton>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
       <div className="relative pt-[58px]  !z-[1]">
          <div className="bg-[#ffffff] mx-[10px] shadow-[0_0_10px_0_#00000021] relative overflow-hidden rounded-t-[14px] ">
            {/* Top Button Bar */}
            <div className="flex items-center justify-between px-2 py-2">
              <div className="flex items-center gap-2">
                <SlidingTabs
                  tabs={[
                    // { id: 1, label: "TMS Users" },
                    { id: 2, label: "IFTA" },
                    { id: 3, label: "Policies" },
                  ]}
                  selectedTab={selectedTab}
                  onTabChange={clickTab}
                />
              </div>
            </div>
            {/* Table */}
            {/* {selectedTab === 1 && <Company ref={companyRef}></Company>} */}

            {selectedTab === 2 && (
              <IFtAdetails
                selectedTab={iftaSelectedTab}
                setSelectedTab={setIFTASelectedTab}
                ref={IFTARef}
              ></IFtAdetails>
            )}

            {selectedTab === 3 && (
              <PoliciesPlans
                ref={PoliciesRef}
                selectedTab={PoliciesSelectedTab}
                setSelectedTab={setPoliciesSelectedTab}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
